import React from 'react';
import { Modal, Table, Button } from 'antd';
import { Employee, KpiQuestionaire } from './types';
import { getQuestionaireColumns } from './KpiHelper';

interface AddKpiModalProps {
  isAddKpiModalOpen: boolean;
  handleCloseAddKpiModal: () => void;
  selectedEmployee: Employee | null;
  handleSaveKpiModal: () => void;
  isFormValid: boolean;
  questionaireList: KpiQuestionaire[];
  modalLoading: boolean;
  questionnaireInput: Record<number, { target?: number; actual?: number; weight?: number }>;
  handleQuestionaireInputChange: (id: number, field: 'target' | 'weight' | 'actual', value: number | null) => void;
  submitLoading?: boolean;
}

const AddKpiModal: React.FC<AddKpiModalProps> = ({
  isAddKpiModalOpen,
  handleCloseAddKpiModal,
  selectedEmployee,
  handleSaveKpiModal,
  isFormValid,
  questionaireList,
  modalLoading,
  questionnaireInput,
  handleQuestionaireInputChange,
  submitLoading
}) => {
  const columns = getQuestionaireColumns(questionnaireInput, handleQuestionaireInputChange);

  return (
    <Modal
      title={`Add KPI for ${selectedEmployee?.firstName || ''} ${selectedEmployee?.lastName || ''}`}
      open={isAddKpiModalOpen}
      onCancel={handleCloseAddKpiModal}
      width={1400}
      className="add-kpi-modal"
      bodyStyle={{ height: 600 }}
      footer={
        <div className="flex justify-end gap-3">
          <Button key="cancel" className="addButton secondary" onClick={handleCloseAddKpiModal} disabled={modalLoading}>Cancel</Button>
          <Button key="submit" loading={submitLoading} className="addButton" type="primary" onClick={handleSaveKpiModal} disabled={!isFormValid || modalLoading}>Save</Button>
        </div>
      }
    >
      <Table
        columns={columns}
        dataSource={questionaireList}
        loading={modalLoading}
        pagination={false}
        rowKey="kpiQuestionaireId"
        scroll={{ y: 500 }}
        bordered
        size="middle"
      />
      <div className="total-weight-container">
        Total : {Object.values(questionnaireInput).reduce((sum, item) => sum + (item.weight || 0), 0).toFixed(0)} %
      </div>
    </Modal>
  );
};

export default AddKpiModal;
